module.exports = __webpack_public_path__ + "static/media/icon_search_black.67eecf35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Icons/icon_search_black.svg
// module id = 801
// module chunks = 0